const NewExperienceEntity = {
    Period: {
        From: {_attributes: {month: "", year: ""}}, To: {_attributes: {month: "", year: ""}}, Current: {_text: 'false'}
    },
    Position: {
        Label: {
            _text: ""
        }
    },
    Activities: {},
    ProjectDescription: {_cdata: ""},
    Responsibilities: {_cdata: ""},
    Environment: {_cdata: ""},
    Employer: {Name: {_text: ""}},
};
export default NewExperienceEntity;